import moment from 'moment';

import Tooltip from '~/components/RedesignedTooltip';

const format = 'dddd, MMMM Do YYYY, h:mm:ss A';

export default function TimeAgo({ time, ...props }) {
  const timeAgo = moment(time).fromNow();
  const title = moment(time).format(format);

  return (
    <Tooltip title={title}>
      <time dateTime={time} {...props}>
        {timeAgo}
      </time>
    </Tooltip>
  );
}

TimeAgo.propTypes = {
  time: PropTypes.string.isRequired,
};
